import React from 'react';
import { Text, Box, Center, VStack, Heading, HStack } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import { useTokens } from '../../../context/TokenProvider';
import SearchIcon from '../../icons/SearchIcon/SeachIcon';
const NoResultsFoundIndicator = (props) => {
    const tokens = useTokens();
    const styles = {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        border: '3px solid',
        borderColor: tokens.Neutral200,
        background: tokens.Neutral500,
        'svg path': {
            fill: tokens.IconWhite100,
        },
    };
    return (React.createElement(Box, { py: tokens.Spacing06 },
        React.createElement(VStack, null,
            React.createElement(HStack, null,
                props.useIcon && (React.createElement(Center, { sx: styles },
                    React.createElement(SearchIcon, null))),
                React.createElement(Heading, { "data-testid": "no_results_header", as: "h2", variant: "dk-800-lt-4" }, props.mainText ?? localise('NO_RESULTS_FOUND'))),
            props.subText && React.createElement(Text, { variant: "md-600-rg-3" }, props.subText))));
};
export default NoResultsFoundIndicator;
